import { useRef, useState } from "react";
import { IoIosArrowDown } from "react-icons/io";
import SimpleReactValidator from "simple-react-validator";
import ServiceEnquiry from "../../services/servicesEnquiry";
import { toast } from "react-toastify";

let goodsPercentage = [
  'None',
  "10%",
  "20%",
  "30%",
  "40%",
  "50%",
  "60%",
  "70%",
  "80%",
  "90%",
  "100%",
];

const CargoEnquiryForm = ({ handleClose, type }) => {
  const [, setForceUpdate] = useState("");
  const [loader, setLoader] = useState(false);

  const [inputValue, setInputValue] = useState({
    name: "",
    phone: "",
    email: "",
    pickup_address: "",
    delivery_address: "",
    description: "",
    shipping_mode: "",
    // packing_qty: "",
    packing_dimension: "",
    // total_weight: "",
    shipping_goods: "",
    special_request: "",
  });

  const handleChange = (event) => {
    setInputValue({ ...inputValue, [event.target.name]: event.target.value });
  };
  const validator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: setForceUpdate },
      messages: {
        required: "Required",
      },
    })
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    // setLoader(true)
    let validate = null;

    if (inputValue) {
      let payload = {
        ...inputValue,
        ...(type === "CONSOLIDATION" && { type: "CONSOLIDATION" }),
      };

      validate = validator.current.allValid();
      if (validate) {
        setLoader(true);
        ServiceEnquiry.cargoEnquiry(payload)
          .then((res) => {
            setLoader(false);
            if (res.status === true) {
              toast.success(res.message);
              handleClose();
              setInputValue({});
            } else {
              toast.error(res.message);
            }
          })
          .catch((error) => {
            setLoader(false);
            console.log(error);
          });
      } else {
        setLoader(false);
        validator.current.showMessages();
      }
    }
  };

  return (
    <div className="container p-4">
      <div className="row ">
        <form onSubmit={(e) => handleSubmit(e)}>
          <div className="row">
            {/* Name */}
            <div className="mb-3 col-md-6 position-relative">
              <label className="form-label mb-0">
                Customer Name<span className="text-danger">*</span>
              </label>
              <input
                className="form-control p-3"
                type="text"
                min="1"
                onChange={(e) => {
                  handleChange(e);
                }}
                name="name"
                placeholder="Enter Name"
                value={inputValue.name}
              />
              {validator.current.message("Name", inputValue?.name, "required", {
                className: "text-danger",
              })}
            </div>

            {/* Phone */}
            <div className="mb-3 col-md-6 position-relative">
              <label className="form-label mb-0">
                Contact Number<span className="text-danger">*</span>
              </label>
              <input
                onChange={(e) => {
                  handleChange(e);
                }}
                className="form-control p-3"
                type="number"
                min="1"
                name="phone"
                placeholder="Enter Phone No."
                value={inputValue.phone}
              />
              {validator.current.message(
                "Mobile",
                inputValue?.phone,
                "required",
                {
                  className: "text-danger",
                }
              )}
            </div>

            {/* Email */}
            <div className="mb-3 col-md-6 position-relative">
              <label className="form-label mb-0">
                Email Address<span className="text-danger">*</span>
              </label>
              <input
                className="form-control p-3"
                type="email"
                onChange={(e) => {
                  handleChange(e);
                }}
                min="1"
                name="email"
                placeholder="Enter Email"
                value={inputValue.email}
              />
              {validator.current.message(
                "Email",
                inputValue?.email,
                "required",
                {
                  className: "text-danger",
                }
              )}
            </div>
            {/* Pickup Address */}
            <div className="mb-3 col-md-6 position-relative">
              <label className="form-label mb-0">
                Pickup  Address<span className="text-danger">*</span>
              </label>
              <input
                className="form-control p-3"
                type="text"
                onChange={(e) => {
                  handleChange(e);
                }}
                name="pickup_address"
                placeholder="Enter Pickup Address"
                value={inputValue.pickup_address}
              />
              {validator.current.message(
                "Pickup Address",
                inputValue?.pickup_address,
                "required",
                {
                  className: "text-danger",
                }
              )}
            </div>

            {/* Delivery Address */}
            <div className="mb-3 col-md-6 position-relative">
              <label className="form-label mb-0">Delivery  Address</label>
              <input
                className="form-control p-3"
                type="text"
                onChange={(e) => {
                  handleChange(e);
                }}
                name="delivery_address"
                placeholder="Enter Delivery Address"
                value={inputValue.delivery_address}
              />
              {validator.current.message(
                "Delivery Address",
                inputValue?.delivery_address,
                "required",
                {
                  className: "text-danger",
                }
              )}
            </div>

            {/* Cargo Description */}
            <div className="mb-3 col-md-6 position-relative">
              <label className="form-label mb-0">Cargo Description</label>
              <input
                className="form-control p-3"
                type="text"
                onChange={(e) => {
                  handleChange(e);
                }}
                name="description"
                placeholder="Enter Detailed description of the goods "
                value={inputValue.description}
              />
              {validator.current.message(
                "Description",
                inputValue?.description,
                "required",
                {
                  className: "text-danger",
                }
              )}
            </div>

            {/* Shipping Mode */}
            <div className="mb-3 col-md-6 position-relative">
              <label className="form-label mb-0">
                Shipping Mode<span className="text-danger">*</span>
              </label>
              <select
                className="form-control normal_input "
                style={{
                  height: "58px",
                  fontSize:'14px',
                  color: `${inputValue?.shipping_mode ? "" : "#999"}`,
                }}
                name="shipping_mode"
                onChange={(e) => {
                  handleChange(e);
                }}
                value={inputValue.shipping_mode}
              >
                <option selected disabled value="" className="placeholder-option">
                  Select Shipping Mode
                </option>
                <option value="Air Freight">Air Freight</option>
                <option value="Ocean Freight">Ocean Freight</option>
                <option value="Road Freight">Road Freight</option>
              </select>
              {validator.current.message(
                "shipping Mode",
                inputValue?.shipping_mode,
                "required",
                {
                  className: "text-danger",
                }
              )}
            </div>
            {/* Packing Qty. */}
            {/* <div className="mb-3 col-md-6 position-relative">
              <label className="form-label mb-0">
                Packing Qty.<span className="text-danger">*</span>
              </label>
              <input
                className="form-control p-3"
                type="number"
                onChange={(e) => {
                  handleChange(e);
                }}
                name="packing_qty"
                placeholder="Enter Packing Qty."
                value={inputValue.packing_qty}
              />
              {validator.current.message(
                "Packing Qty.",
                inputValue?.packing_qty,
                "required",
                {
                  className: "text-danger",
                }
              )}
            </div> */}
            {/* Packing Dimension */}
            <div className="mb-3 col-md-6 position-relative">
              <label className="form-label mb-0">
                Packaging Details
                <span className="text-danger">*</span>
              </label>
              <input
                className="form-control p-3"
                type="text"
                onChange={(e) => {
                  handleChange(e);
                }}
                name="packing_dimension"
                placeholder="Enter Weight & Dimensions of Each Pkg"
                value={inputValue.packing_dimension}
              />
              {validator.current.message(
                "Packing Dimension",
                inputValue?.packing_dimension,
                "required",
                {
                  className: "text-danger",
                }
              )}
            </div>
            {/* Total Weight */}
            {/* <div className="mb-3 col-md-6 position-relative">
              <label className="form-label mb-0">
                Total Weight (KGS)<span className="text-danger">*</span>
              </label>
              <input
                className="form-control p-3"
                type="number"
                onChange={(e) => {
                  handleChange(e);
                }}
                name="total_weight"
                placeholder="Enter Weight"
                value={inputValue.total_weight}
              />
              {validator.current.message(
                "Weight",
                inputValue?.total_weight,
                "required",
                {
                  className: "text-danger",
                }
              )}
            </div> */}
            {/* Goods */}
            <div className="mb-3 col-md-6 position-relative">
              <label className="form-label mb-0">
                How much % of Goods is fragile in your Shipment?<span className="text-danger">*</span>
              </label>
              <select
                className="form-control normal_input"
                style={{
                  height: "58px",
                   fontSize:'14px',
                  color: `${inputValue?.shipping_goods ? "" : "#999"}`,
                }}
                name="shipping_goods"
                onChange={(e) => {
                  handleChange(e);
                }}
                value={inputValue.shipping_goods}
              >
                <option selected disabled value="">
                  Goods %
                </option>

                {goodsPercentage.map((item, index) => {
                  return (
                    <option key={index} value={item}>
                      {item}
                    </option>
                  );
                })}
              </select>
              {validator.current.message(
                "Moving Size",
                inputValue?.shipping_goods,
                "required",
                {
                  className: "text-danger",
                }
              )}
           
            </div>
            {/* Special Request */}
            <div className="mb-3 col-md-12 position-relative">
              <label className="form-label mb-0">Special Request</label>
              <input
                className="form-control p-3"
                type="text"
                onChange={(e) => {
                  handleChange(e);
                }}
                name="special_request"
                placeholder="Enter Special Request"
                value={inputValue.special_request}
              />
            </div>
          </div>
          <div className="d-flex justify-content-center">
            <button
              type="button"
              onClick={handleClose}
              className="btn getquoteBtn cancel mb-3 mx-2"
              style={{ padding: " 27px 56px" }}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn getquoteBtn mb-3 mx-2"
              style={{ padding: " 27px 56px" }}
            >
              {(loader && (
                <div class="spinner-grow text-light" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              )) ||
                "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CargoEnquiryForm;
